<template>
  <div class="couponContainer">
    <div class="grid imgGrid">
      <img class="imgContainer" src="@/assets/images/mosquita_promo_code.png" />
      <p class="nunitoBold subheaderText">{{ $t('k_redeem_coupon') }}</p>
      <p class="ralewayRegular subheaderTextCoupon">
        {{ $t('k_coupon_info') }}
      </p>
    </div>
    <form action="#" @submit.prevent="submit">
      <div class="formContainer mt-10">
        <div class="formElement">
          <label class="ralewayRegular formInputLabel" for="coupon">{{
            $t('k_promo_title')
          }}</label>
          <input
            class="formInput ralewayRegular"
            type="text"
            name="coupon"
            v-model="coupon"
            v-bind:placeholder="$t('k_promo_title')"
          />
        </div>
      </div>

      <div class="grid mt-10">
        <div class="stButton registerButton">
          <div class="stButtonCaption nunitoBold" v-on:click="submit()">
            {{ $t('k_redeem_title') }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import api from '.././plugins/api'
import { mapState } from 'vuex'
import { trackEvent } from '../plugins/analyticsTracker'

export default {
  data() {
    return {
      coupon: '',
      confirmMessage: '',
      error: false,
      errorText: '',
      accept: false
    }
  },
  computed: {
    ...mapState({
      email: state => state.userInfo?.coupons
    })
  },
  mounted: function() {
    const code = this.$route.query.code
    this.coupon = code ? code : null
  },
  methods: {
    submit: async function() {
      trackEvent(this.$constants.WEB_REDEEM_REDEEM)
      try {
        const urlCoupon = process.env.VUE_APP_BACKEND_URL
        const r = await api.post(urlCoupon + '/user/coupon', {
          couponId: this.coupon,
          lang: this.$i18n.locale
        })
        trackEvent(this.$constants.WEB_PROMO_REDEEMED)
        this.$router.push({
          path: '/coupon-active'
        })
        this.confirmMessage = 'Coupon claimed correctly'
      } catch (errorFirebase) {
        trackEvent(this.$constants.WEB_PROMO_ERROR)
        await this.$store.dispatch('setError', {
          errorKey: 'k_coupon_error_title',
          errorSubKey: 'k_redeem_error',
          errorSubKeyParams: [
            {
              key: 'k_footer_contact_us',
              link: 'mailto:support@smarttales.app'
            }
          ],
          errorImage: '@/assets/images/mosquita_error.png',
          redirect: '/coupon'
        })
        this.$router.push({
          path: '/error'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.couponContainer {
  .subheaderTextCoupon {
    grid-row: 3;
    grid-column: 2/12;
    font-size: 0.8765em;
    color: var(--formColor);
    text-align: left;
  }
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
